import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  signal,
} from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { InputFieldComponent } from '../../../shared-extra/components/input-field/input-field.component';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';

export const allFonts = [
  'AkkuratLL',
  'Abril Fatface',
  'Almarai',
  'Anton',
  'Archivo',
  'Archivo Black',
  'Bitter',
  'Bodoni Moda',
  'Climate Crisis',
  'Cormorant',
  'Dancing Script',
  'DM Sans',
  'EB Garamond',
  'Eczar',
  'Epilogue',
  'Great Vibes',
  'Instrument Serif',
  'Inter',
  'Lato',
  'League Spartan',
  'Libre Baskerville',
  'Manjari',
  'Manrope',
  'Marcellus',
  'Merriweather',
  'MonteCarlo',
  'Montserrat',
  'Newsreader',
  'Nunito Sans',
  'Ojuju',
  'PT Serif',
  'Parisienne',
  'Philosopher',
  'Playfair Display',
  'Poppins',
  'Prata',
  'Quattrocento',
  'Quicksand',
  'Raleway',
  'Roboto',
  'Sansita',
  'Shrikhand',
  'Space Grotesk',
  'Spectral',
  'Syne',
  'Syne Mono',
  'Tenor Sans',
  'Urbanist',
  'Work Sans',
  'Young Serif',
  'Zilla Slab',
];

@Component({
  selector: 'app-font-selection-menu',
  templateUrl: './font-selection-menu.component.html',
  styleUrls: ['./font-selection-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonMenuItemComponent, SvgComponent, FormsModule, ReactiveFormsModule, InputFieldComponent],
})
export class FontSelectionMenuComponent implements OnDestroy {
  @Input() currentFont: string;
  @Input() defaultFont = 'AkkuratLL';
  @Input() allowFontReset: boolean;
  @Output() onSelected = new EventEmitter();
  @Input() allowRemoveOverrides: boolean;
  @Output() onRemoveOverrides = new EventEmitter();
  imageLinks = allFonts.reduce((map, font) => {
    map.set(font, `url("/assets/font-images/${font.toLowerCase()}.png")`);
    return map;
  }, new Map());
  destoyed$ = new Subject<void>();
  form = new FormGroup({
    search: new FormControl(''),
  });
  searchValue = signal<string>(undefined);

  fonts = computed(() => {
    const searchValue = this.searchValue()?.toLowerCase()?.trim();
    if (!searchValue) return allFonts;
    return allFonts.filter(font => font.toLowerCase().includes(searchValue));
  });

  constructor() {
    this.form.controls.search.valueChanges.pipe(takeUntil(this.destoyed$)).subscribe(value => {
      this.searchValue.set(value);
    });
  }

  ngOnDestroy(): void {
    this.destoyed$.next();
    this.destoyed$.complete();
  }
}
